import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Ref, User, UserService} from '@lifeislife/lifeislife-domain';
import {CustomerFrontErrorHandler} from '../../error.handler';

@Component({
  selector: 'cf-user-password-modal',
  templateUrl: './user-password-model.component.html',
  styleUrls: ['./user-password-model.component.scss'],
})
export class UserPasswordModelComponent implements OnInit {

  password1: string;
  password2: string;
  busy$ = new BehaviorSubject<boolean>(false);

  @Output()
  success = new EventEmitter();

  constructor(
    private userService: UserService,
    private errorService: CustomerFrontErrorHandler,
  ) {

  }

  ngOnInit(): void {
  }

  onSubmit(valid: boolean) {
    if (valid === false || this.password1 == null || this.password1.length === 0 || this.password1 !== this.password2) {
      return;
    }

    this.busy$.next(true);
    this.userService.setLoggedUserPassword$(this.password1)
      .subscribe(user => this.onSuccess(user),
        error => this.onError(error));
  }

  private onSuccess(user: Ref<User>) {
    this.busy$.next(false);
    this.success.emit(true);
  }

  private onError(error: any) {
    this.busy$.next(false);
    // Ignore here, but forward to backend
    this.errorService.handleError(error);
  }
}
